import * as React from "react";
import Sidemenu from "../components/Sidemenu";
import Topbar from "../components/Topbar";
import { useState } from "react";
function Dummylayout({ doggle }){
    const [toggle, setToggle] = useState(true);

    const Toggle = () => {
        setToggle(!toggle);
    };
    return (
        <div className="container-fluid">
            <div className="row Main_row">
                {toggle && (
                    <div className="col-lg-2 bg-white">
                        <Sidemenu toggle={toggle} />
                    </div>
                )}

                <div className="col mainmenu">
                    {/* <Topbar Toggle={Toggle} /> */}
                    <Topbar Toggle={Toggle} />
                </div>
            </div>
        </div>
    );
}


export default Dummylayout;